import { createFeatureSelector } from "@ngrx/store";
import { paginationSliceKey, PaginationState } from "./pagination-slice.config";

export const selectPaginationFeature = createFeatureSelector<PaginationState>(paginationSliceKey);
